import Dispatcher from 'common/events/dispatcher';
import * as LucidService from 'common/services/lucid-service';

/* Special case for single building */
export const getBuilding = (buildingId) => {
  const dispatch = (building) => {
    Dispatcher.dispatch({
      action: 'ADD_BUILDINGS',
      buildings: building.data ? [building.data] : [],
      count: building.data ? 1 : 0,
    });
  };

  const request = (id, url) => {
    if (url) {
      LucidService.get(url).then((building) => {
        dispatch(building);
      });
    } else {
      LucidService.building(id).then((building) => {
        dispatch(building);
      });
    }
  };

  request(buildingId);
};

export const getBuildings = (parentId, perPage, fields, enabled) => {
  const dispatch = (buildings) => {
    Dispatcher.dispatch({
      action: 'ADD_BUILDINGS',
      buildings: buildings.data,
      count: buildings.total_count,
    });
  };

  const request = function (id, url) {
    if (url) {
      LucidService.get(url).then((buildings) => {
        dispatch(buildings);
        if (buildings.links.next) {
          request(id, buildings.links.next);
        }
      });
    } else {
      LucidService.buildings(id, perPage, fields, enabled).then((buildings) => {
        dispatch(buildings);
        if (buildings.links.next) {
          request(id, buildings.links.next);
        }
      });
    }
  };

  request(parentId);
};

export const getOrganizationPrefs = (orgId) => {
  LucidService.organizationPrefs(orgId).then((result) => {
    Dispatcher.dispatch({
      action: 'UPDATE_ORG_PREFS',
      prefs: result || {},
    });
  });
};

function handleDashSuccess(result) {
  Dispatcher.dispatch({
    action: 'UPDATE_REPORTS_DASHBOARD',
    reports: result,
  });
}
function handleDashError(error) {
  // An ugly way to detect server 500 error
  if (typeof error === 'string' && error.indexOf('cannot GET') === 0) {
    Dispatcher.dispatch({
      action: 'ERROR_REPORTS_DASHBOARD',
      error,
    });
  } else if (typeof error === 'object' && 'message' in error) {
    // session timed out?
    Dispatcher.dispatch({
      action: 'ERROR_REPORTS_DASHBOARD',
      error: error.message,
    });
  } else {
    // Don't swallow the error
    setTimeout(() => {
      throw error;
    });
  }
}
export const getReportsDashboard = (dashboardId) => {
  LucidService.reportsDashboard(dashboardId)
    .then(handleDashSuccess)
    .catch(handleDashError);
};
export const getReportsDashboardByChapter = (chapterId) => {
  LucidService.reportsDashboardByChapter(chapterId)
    .then(handleDashSuccess)
    .catch(handleDashError);
};

// assetId is optional
export const getAssetReportsData = (assetId) => {
  LucidService.assetReports(assetId).then((result) => {
    Dispatcher.dispatch({
      action: 'UPDATE_REPORTS',
      reports: result,
    });
  });
};

// Gets broad info on single tenant
export const getTenant = (tenantId) => {
  LucidService.tenant(tenantId).then((result) => {
    Dispatcher.dispatch({
      action: 'UPDATE_TENANT_DETAILS',
      tenant: result.data,
    });
  });
};

export const updateOrganizationPrefs = (orgId, prefs) => {
  LucidService.updateOrganizationPrefs(orgId, prefs).then(() => {
    Dispatcher.dispatch({
      action: 'UPDATE_ORG_PREFS',
      prefs,
    });
  });
};

export const updateReportConfiguration = (reportId, config) => {
  LucidService.updateReportConfiguration(reportId, config).then(() => {
    // noop
  });
};
